import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/inventory/locations/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/inventory/locations`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/inventory/locations/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/inventory/locations`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/inventory/locations/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/inventory/locations/${url.id}`, data, config),
};

export default requests;
